import { render, staticRenderFns } from "./index.vue?vue&type=template&id=78c4c84f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=78c4c84f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c4c84f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78c4c84f')) {
      api.createRecord('78c4c84f', component.options)
    } else {
      api.reload('78c4c84f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=78c4c84f&scoped=true", function () {
      api.rerender('78c4c84f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/frame/page/setting/index.vue"
export default component.exports